<template>
	<page>
		<module title="基本信息" height="auto">
			<c-detail>
				<c-detail-item label="订单类型">
					<template v-slot="{data}">
						<span v-if="orderDetail.order_type==1" style="color:#888888">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==2" style="color:#ff00ff">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==3" style="color:#000000">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==4" style="color:#ff0000">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==5" style="color:#707070">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==6" style="color:#aaaa00">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==7" style="color:#0000ff">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==8" style="color:#ff00cc">{{orderTypeName[orderDetail.order_type]}}</span>
					</template>
				</c-detail-item>
				<c-detail-item label="结算状态" >
					<template v-slot="{data}">
						<span v-if="orderDetail.state==1" style="color:darkgray">{{transStateName[orderDetail.state]}}</span>
						<span v-if="orderDetail.state==2" style="color:brown">{{transStateName[orderDetail.state]}}</span>
						<span v-if="orderDetail.state==3" style="color:darkgreen">{{transStateName[orderDetail.state]}}</span>
						<span v-if="orderDetail.state==4" style="color:red">{{transStateName[orderDetail.state]}}</span>
					</template>
				</c-detail-item>

				<c-detail-item label="订单号" >
                    <a @click="navigateTo(`/order_detail/${orderDetail.order_number}`)">{{orderDetail.order_number}}</a>
				</c-detail-item>
				<c-detail-item label="下单会员" >
					{{orderDetail.nick_name}}【{{orderDetail.user_manage_mobilephone}}】
				</c-detail-item>
				<c-detail-item label="下单时间" >
					{{orderDetail.create_date}}
				</c-detail-item>
				<c-detail-item label="支付时间" >
					{{orderDetail.payment_date}}
				</c-detail-item>
				<c-detail-item label="商品数量" >
					{{orderDetail.product_count}}
				</c-detail-item>
				<c-detail-item label="商品金额" >
					￥{{parseFloat(orderDetail.product_money||0).toFixed(2)}}
                    <span v-if="orderDetail.custom_money && parseFloat(orderDetail.custom_money||0) > 0">
                        (含定制费：￥{{parseFloat(orderDetail.custom_money||0).toFixed(2)}})
                    </span>
				</c-detail-item>
				<c-detail-item label="运费" >
					￥{{parseFloat(orderDetail.logistics_money||0).toFixed(2)}}
				</c-detail-item>
				<c-detail-item label="其他费用" >
					<span v-if="orderDetail.other_fee"  style="color:#ff00ff">￥{{parseFloat(orderDetail.other_fee||0).toFixed(2)}}</span>
					<span v-else>--</span>
				</c-detail-item>
			</c-detail>
		</module>
		<module :title="formulasTip" height="auto">
		</module>
        <module>
            <module-tab title="清分明细">
                <div style="padding: 30px 30px 40px;">
                    <dt>基础清分数据</dt>
                    <c-table v-model="settlementList" height="auto" :paging="false" border>
                        <c-table-column
                                label="费用类型"
                                name="fee_name"
                                width="130"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.fee_code == 106" style="color: red">
                                  {{data.fee_name||'--'}}
                                </span>
                                <span v-else>{{data.fee_name||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="清分状态"
                                name="settlement_state"
                                width="80"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.settlement_state==1" style="color:darkgray">{{transStateName[data.settlement_state]}}</span>
                                <span v-if="data.settlement_state==2" style="color:brown">{{transStateName[data.settlement_state]}}</span>
                                <span v-if="data.settlement_state==3" style="color:darkgreen">{{transStateName[data.settlement_state]}}</span>
                                <span v-if="data.settlement_state==4" style="color:red">{{transStateName[data.settlement_state]}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="结算数量"
                                name="settled_count"
                                width="80"
                        >
                            <template v-slot="{data}">
                                <span>{{data.settled_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="结算费用"
                                name="settled_amount"
                                width="100"
                        >
                            <template v-slot="{data}">
                                <span>￥{{parseFloat(Math.abs(data.settled_amount)||0).toFixed(2)}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="清分到账账户"
                                name="return_type"
                                width="250"
                        >
                            <template v-slot="{data}">
                            <span v-if="data.account_type==1" style="color:forestgreen">
                              【平台】
                            </span>
                                <span v-if="data.account_type==2" style="color:#707070">
                              【商家】
                            </span>
                                <span v-if="data.account_type==1" style="color:forestgreen">{{data.account_name}}</span>
                                <span v-if="data.account_type==2" style="color:#707070">{{data.company_name}}
                              <span v-if="data.shop_name && data.shop_name!=data.company_name">【{{data.shop_name}}】</span>
                            </span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="预估结算数量"
                                name="settle_count"
                                width="110"
                        >
                            <template v-slot="{data}">
                                <span>{{data.settle_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="预估结算费用"
                                name="settled_amount"
                                width="110"
                        >
                            <template v-slot="{data}">
                                <span>
                                    ￥{{parseFloat(Math.abs(data.settle_amount)||0).toFixed(2)}}
                                </span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="仅退款数量"
                                name="refund_count"
                                width="100"
                        >
                            <template v-slot="{data}">
                                <span>{{data.refund_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="仅退款金额"
                                name="refund_amount"
                                width="100"
                        >
                            <template v-slot="{data}">
                            <span v-if="data.settle_amount">
                              ￥{{parseFloat(data.refund_amount||0).toFixed(2)}}
                            </span>
                                <span v-else>--</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="退货退款数量"
                                name="return_count"
                                width="110"
                        >
                            <template v-slot="{data}">
                                <span>{{data.return_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="退货退款金额"
                                name="return_amount"
                                width="110"
                        >
                            <template v-slot="{data}">
                            <span v-if="data.return_amount">
                              ￥{{parseFloat(data.return_amount||0).toFixed(2)}}
                            </span>
                                <span v-else>--</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="关联商家"
                                name="shop_name"
                                width="200"
                                v-if="systemConfig.pt_mode == 2"
                        >
                            <template v-slot="{data}">
                                {{data.company_name||'--'}}
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="清分时间"
                                name="last_settled_date"
                                width="150"
                        >
                            <template v-slot="{data}">
                                {{data.last_settled_date||'--'}}
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="创建时间"
                                name="create_date"
                                width="150"
                        ></c-table-column>

                    </c-table>
                    <div style="height:20px;"></div>
                    <dt v-if="retailList && retailList.length > 0">代理分销清分数据</dt>
                    <c-table v-if="retailList && retailList.length > 0" v-model="retailList" height="auto" :paging="false" border>
                        <c-table-column
                                label="费用类型"
                                name="fee_name"
                                width="90"
                        >
                            <template v-slot="{data}">
                                <span style="color: red">{{data.fee_name||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="清分状态"
                                name="settlement_state"
                                width="80"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.settlement_state==1" style="color:darkgray">{{transStateName[data.settlement_state]}}</span>
                                <span v-if="data.settlement_state==2" style="color:brown">{{transStateName[data.settlement_state]}}</span>
                                <span v-if="data.settlement_state==3" style="color:darkgreen">{{transStateName[data.settlement_state]}}</span>
                                <span v-if="data.settlement_state==4" style="color:red">{{transStateName[data.settlement_state]}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="结算数量"
                                name="settled_count"
                                width="80"
                        >
                            <template v-slot="{data}">
                                <span>{{data.settled_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="结算费用"
                                name="settled_amount"
                                width="100"
                        >
                            <template v-slot="{data}">
                            <span v-if="data.settled_amount<0" style="color: red">
                              ￥{{parseFloat(Math.abs(data.settled_amount)||0).toFixed(2)}}
                            </span>
                                <span v-else>￥{{parseFloat(data.settled_amount||0).toFixed(2)}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="预估结算数量"
                                name="settle_count"
                                width="110"
                        >
                            <template v-slot="{data}">
                                <span>{{data.settle_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="预估结算费用"
                                name="settled_amount"
                                width="110"
                        >
                            <template v-slot="{data}">
                            <span v-if="data.settle_amount<0" style="color: red">
                              ￥{{parseFloat(Math.abs(data.settle_amount)||0).toFixed(2)}}
                            </span>
                                <span v-else>￥{{parseFloat(data.settle_amount||0).toFixed(2)}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="仅退款数量"
                                name="refund_count"
                                width="100"
                        >
                            <template v-slot="{data}">
                                <span>{{data.refund_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="仅退款金额"
                                name="refund_amount"
                                width="100"
                        >
                            <template v-slot="{data}">
                            <span v-if="data.settle_amount">
                              ￥{{parseFloat(data.refund_amount||0).toFixed(2)}}
                            </span>
                                <span v-else>--</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="退货退款数量"
                                name="return_count"
                                width="110"
                        >
                            <template v-slot="{data}">
                                <span>{{data.return_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="退货退款金额"
                                name="return_amount"
                                width="110"
                        >
                            <template v-slot="{data}">
                            <span v-if="data.return_amount">
                              ￥{{parseFloat(data.return_amount||0).toFixed(2)}}
                            </span>
                                <span v-else>--</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="清分时间"
                                name="last_settled_date"
                                width="150"
                        >
                            <template v-slot="{data}">
                                {{data.last_settled_date||'--'}}
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="创建时间"
                                name="create_date"
                                width="150"
                        ></c-table-column>

                        <c-table-column
                            type="button"
                            fixed="right"
                            label="操作"
                            width="100"
                        >
                          <template v-slot="{data}">
                            <c-table-button power="m_reward_settlement" @click="navigateTo(`/reward/detail/${orderNumber}`)">详情</c-table-button>
                          </template>
                        </c-table-column>
                    </c-table>
                </div>
            </module-tab>
            <module-tab title="按商家汇总" v-if="systemConfig.pt_mode == 2">
                <div style="padding: 30px 30px 40px;">
                    <c-table v-model="stationedList" height="auto" :paging="false" border>
                        <c-table-column
                                label="关联商家"
                                name="shop_name"
                                width="200"
                                v-if="systemConfig.pt_mode == 2"
                        >
                            <template v-slot="{data}">
                                {{data.company_name||'--'}}
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="结算数量"
                                name="settled_count"
                                width="80"
                        >
                            <template v-slot="{data}">
                                <span>{{data.settled_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="结算费用"
                                name="settled_amount"
                                width="100"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.settled_amount<0" style="color: red">
                                  ￥{{parseFloat(data.settled_amount||0).toFixed(2)}}
                                </span>
                                <span v-else>￥{{parseFloat(data.settled_amount||0).toFixed(2)}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="预估结算数量"
                                name="settle_count"
                                width="110"
                        >
                            <template v-slot="{data}">
                                <span>{{data.settle_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="预估结算费用"
                                name="settled_amount"
                                width="110"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.settle_amount<0" style="color: red">
                                  ￥{{parseFloat(data.settle_amount||0).toFixed(2)}}
                                </span>
                                <span v-else>￥{{parseFloat(data.settle_amount||0).toFixed(2)}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="仅退款数量"
                                name="refund_count"
                                width="100"
                        >
                            <template v-slot="{data}">
                                <span>{{data.refund_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="仅退款金额"
                                name="refund_amount"
                                width="100"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.settle_amount">
                                  ￥{{parseFloat(data.refund_amount||0).toFixed(2)}}
                                </span>
                                <span v-else>--</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="退货退款数量"
                                name="return_count"
                                width="110"
                        >
                            <template v-slot="{data}">
                                <span>{{data.return_count||'--'}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="退货退款金额"
                                name="return_amount"
                                width="110"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.return_amount">
                                  ￥{{parseFloat(data.return_amount||0).toFixed(2)}}
                                </span>
                                <span v-else>--</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="最近清分时间"
                                name="last_settled_date"
                                width="150"
                        >
                            <template v-slot="{data}">
                                {{data.last_settled_date||'--'}}
                            </template>
                        </c-table-column>
                    </c-table>
                </div>
            </module-tab>
            <module-tab title="按账户汇总">
              <div style="padding: 30px 30px 40px;">
                <c-table v-model="accountList" height="auto" :paging="false" border>
                  <c-table-column
                      label="清分到账账户"
                      name="return_type"
                      width="250"
                  >
                    <template v-slot="{data}">
                        <span v-if="data.account_type==1" style="color:forestgreen">
                          【平台】
                        </span>
                        <span v-if="data.account_type==2" style="color:#707070">
                          【商家】
                        </span>
                        {{data.account_name}}
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="结算数量"
                      name="settled_count"
                      width="80"
                  >
                    <template v-slot="{data}">
                      <span>{{data.settled_count||'--'}}</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="结算费用"
                      name="settled_amount"
                      width="100"
                  >
                    <template v-slot="{data}">
                      <span v-if="data.settled_amount<0" style="color: red">
                        ￥{{parseFloat(data.settled_amount||0).toFixed(2)}}
                      </span>
                      <span v-else>￥{{parseFloat(data.settled_amount||0).toFixed(2)}}</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="预估结算数量"
                      name="settle_count"
                      width="110"
                  >
                    <template v-slot="{data}">
                      <span>{{data.settle_count||'--'}}</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="预估结算费用"
                      name="settled_amount"
                      width="110"
                  >
                    <template v-slot="{data}">
                      <span v-if="data.settle_amount<0" style="color: red">
                        ￥{{parseFloat(data.settle_amount||0).toFixed(2)}}
                      </span>
                      <span v-else>￥{{parseFloat(data.settle_amount||0).toFixed(2)}}</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="仅退款数量"
                      name="refund_count"
                      width="100"
                  >
                    <template v-slot="{data}">
                      <span>{{data.refund_count||'--'}}</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="仅退款金额"
                      name="refund_amount"
                      width="100"
                  >
                    <template v-slot="{data}">
                      <span v-if="data.settle_amount">
                        ￥{{parseFloat(data.refund_amount||0).toFixed(2)}}
                      </span>
                      <span v-else>--</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="退货退款数量"
                      name="return_count"
                      width="110"
                  >
                    <template v-slot="{data}">
                      <span>{{data.return_count||'--'}}</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="退货退款金额"
                      name="return_amount"
                      width="110"
                  >
                    <template v-slot="{data}">
                      <span v-if="data.return_amount">
                        ￥{{parseFloat(data.return_amount||0).toFixed(2)}}
                      </span>
                      <span v-else>--</span>
                    </template>
                  </c-table-column>

                  <c-table-column
                      label="最近清分时间"
                      name="last_settled_date"
                      width="150"
                  >
                    <template v-slot="{data}">
                      {{data.last_settled_date||'--'}}
                    </template>
                  </c-table-column>
                </c-table>
              </div>
            </module-tab>
        </module>
	</page>
</template>

<script>
	import {mapState} from "vuex";

  export default {
		name: 'order_settlement_detail',
		props: {
			orderNumber: String
		},
		data() {
			return {
				transStateName: {
					4: '取消结算',
					1: '待结算',
					2: '部分结算',
					3: '全部结算'
				},
				state: [{
					name: '待清分',
					value: 1
				},{
					name: '部分结算',
					value: 2
				},{
					name: '全部结算',
					value: 3
				},{
					name: '取消结算',
					value: 4
				}],
				orderTypeName: {
            1: '普通',
            2: '积分',
            3: '赠品',
            4: '砍价',
            5: '预售订单(全款)',
            6: '预售订单(定金)',
            7: '定制',
            8: '拼团',
            9: '云仓提货',
            10: '送礼',
            11: '抽奖'
				},
				orderDetail: {},
				settlementList: [],
                retailList: [],
                accountList: [],
                stationedList: [],
                incomeExpend:{}
			}
		},
        watch:{//ID变更刷新页面
            orderNumber(){
              this.detail();
            }
        },
		mounted() {
			this.detail();
		},
        computed: {
          ...mapState(['systemConfig']),
          formulasTip(){
              var product_money = 0;    //商品货款
              var stationed_service_money = 0;    //商家服务费
              var product_subsidy_money = 0;              //货款补贴
              // var coupon_subsidy_money = 0;              //优惠券补贴
              var points_subsidy_money = 0;              //积分补贴
              var newmember_subsidy_money = 0;              //新人活动补贴
              for(let i = 0;i<this.settlementList.length;i++){
                  var obj = this.settlementList[i];
                  if (obj.fee_code == '1000'){ //商品货款
                      product_money += parseFloat(obj.settle_amount||0);
                  }
                  if (obj.fee_code == '105'){ //商家服务费
                      stationed_service_money += parseFloat(obj.settle_amount||0);
                  }
                  if (obj.fee_code == '106' && obj.subsidy_type == 1){ //货款补贴
                      product_subsidy_money += parseFloat(obj.settle_amount||0);
                  }
                 /* if (obj.fee_code == '106' && obj.subsidy_type == 2){ //优惠券补贴
                      coupon_subsidy_money += parseFloat(obj.settle_amount||0);
                  }*/
                  if (obj.fee_code == '106' && obj.subsidy_type == 3){ //积分补贴
                      points_subsidy_money += parseFloat(obj.settle_amount||0);
                  }
                  if (obj.fee_code == '106' && obj.subsidy_type == 4){ //新人活动补贴
                      newmember_subsidy_money += parseFloat(obj.settle_amount||0);
                  }
              }//end for
              var tip = "支付商品金额(￥"+parseFloat(this.orderDetail.product_money||0).toFixed(2)+") = ";
              tip = tip + "商家货款(￥"+product_money.toFixed(2)+")";
              if (stationed_service_money != 0){
                  tip = tip + " + 商家服务费(￥"+stationed_service_money.toFixed(2)+")";
              }
              if (product_subsidy_money != 0){
                  tip = tip + " - 货款补贴(￥"+product_subsidy_money.toFixed(2)+")";
              }
              // tip = tip + " - 优惠券补贴(￥"+coupon_subsidy_money.toFixed(2)+")";
              if (points_subsidy_money != 0){
                  tip = tip + " - 积分补贴(￥"+points_subsidy_money.toFixed(2)+")";
              }
              if(newmember_subsidy_money > 0){
                  tip = tip + " - 新人活动补贴(￥"+newmember_subsidy_money.toFixed(2)+")";
              }
              return tip;
          }
        },
		methods: {
			detail() {
				this.request({
					url: '/order/settlement/detail',
					data: {order_number: this.orderNumber},
					loading: true,
					success: data => {
                        if (data.order_info.custom_money && parseFloat(data.order_info.custom_money||0) > 0){
                            data.order_info.product_money =  parseFloat(data.order_info.product_money||0) + parseFloat(data.order_info.custom_money||0);
                        }
                        this.orderDetail = data.order_info;
						this.settlementList = data.settlement_info_list;
						this.retailList = data.retail_info_list;
						this.stationedList = data.stationed_info_list;
						this.accountList = data.account_info_list;
						this.incomeExpend = data.income_expend;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
@import '~@/assets/style/theme'
    dt {
        border-left: 3px solid #000;
        padding-left: 5px;
        margin-bottom: 10px;
        line-height: 18px;
        font-size: 16px;
        font-weight: bold;
    }
    a {
        color: #003DD9;
    }
</style>